import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import dayjs from 'utils/dayjs';

import Icon from 'components/commons/Icon';

import { TitleWrapper, Update, Title } from './styles';

export const SectionTitle = ({
  title,
  none,
  nbu,
  isRefreshTimeDisplayed,
  renderSuffix,
  children,
  titleValue,
}) => {
  return (
    <TitleWrapper nbu={nbu}>
      <Title>
        {children || (
          <FormattedMessage id={title} values={{ date: titleValue }} />
        )}
      </Title>
      {isRefreshTimeDisplayed && !renderSuffix && (
        <Update none={none} nbu={nbu}>
          <Icon name="watch" style={{ margin: '0 5px 1px 0' }} />
          <FormattedMessage id="updated" />
          {` `}
          {dayjs().format('DD.MM.YYYY, hh:mm')}
        </Update>
      )}
      {renderSuffix && renderSuffix()}
    </TitleWrapper>
  );
};

SectionTitle.propTypes = {
  title: PropTypes.string.isRequired,
  none: PropTypes.bool,
  nbu: PropTypes.bool,
  isRefreshTimeDisplayed: PropTypes.bool,
  renderSuffix: PropTypes.func,
  children: PropTypes.node,
  titleValue: PropTypes.string,
};

SectionTitle.defaultProps = {
  none: null,
  nbu: null,
  children: null,
  isRefreshTimeDisplayed: false,
  renderSuffix: null,
  titleValue: null,
};
